import BaseReadOnlyChangeMainTask from "../baseReadOnlyChangeMainTask";
import "../../../commonComponents/readOnlyTable/antReadOnlyTableCustom.scss";

export default class ReviseChangeMainTaskReadOnly extends BaseReadOnlyChangeMainTask {
  constructor(props: any) {
    super(props);
    this.state = this.initReadOnlyState(true);
  }

  handleReturnReason = () => {
    return this.handleReviseReturnReason();
  };

  handleSubmitReason = () => {
    return this.handleReviseSubmitReason();
  };
}
